import { FormikHelpers } from "formik";
import EstablishmentSearchForm from "./EstablishmentSearchForm";
import { useContext } from "react";
import { SydFilterContext } from "src/components/Common/UI/SydFilter/SydFilterContext";
import { isTypeOfEstablishmentSearchForm } from "src/components/Common/UI/SydFilter/SydFilterTypeChecker";

const emptyEstablishmentSearchForm: IEstablishmentSearchForm = {
  sapCode: "",
  unID: "",
  description: "",
  deleted: "",
  placeID: ""
};

const SearchEstablishment = ()  => {
  const sydFilterCtx = useContext(SydFilterContext);

  const activeFilters = sydFilterCtx.activeFilters;
  const clearForm = sydFilterCtx.clearAllFilters;
  const saveFilters  = sydFilterCtx.saveFilters;
  const handleClose = sydFilterCtx.toggleFilterVisibility;

  const initialValues = isTypeOfEstablishmentSearchForm(activeFilters) ? activeFilters as IEstablishmentSearchForm : emptyEstablishmentSearchForm;

  const handleSubmit = async (values: IEstablishmentSearchForm, { setSubmitting }: FormikHelpers<IEstablishmentSearchForm>): Promise<void> => {
    saveFilters(values);
    setSubmitting(false);
    handleClose();
  }

  return (
    <EstablishmentSearchForm initialValues={initialValues} onSubmit={handleSubmit} onClearForm={clearForm} />
  )
}


export default SearchEstablishment;